const VueSlider = require('./vue2-slider')

module.exports = VueSlider
